import { HttpContextToken } from '@angular/common/http';

export type HttpCacheMode = 'default' | 'no-cache' | 'refresh';

export const HTTP_CACHE_MODE = new HttpContextToken<HttpCacheMode>(
    () => 'default',
);
export const HTTP_CACHE_TTL_MS = new HttpContextToken<number | undefined>(
    () => undefined,
);
export const HTTP_CACHE_KEY_SALT = new HttpContextToken<string | undefined>(
    () => undefined,
);
